import React, { useCallback, useRef } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState } from 'draft-js';
import classNames from 'classnames';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import styles from './styles.module.pcss';

type Props = {
  onChangeState: (editorState: EditorState) => void;
  editorState: EditorState;
  onFocus?: () => void;
  editorClassName?: string;
};

const RichTextEditor: React.FC<Props> = (props) => {
  const editorRef = useRef<Editor | null>(null);

  const onChange = useCallback(
    (editorState: EditorState) => {
      props.onChangeState(editorState);
    },
    [props]
  );

  const onFocus = useCallback(() => {
    props.onFocus?.();
  }, [props]);

  return (
    <Editor
      {...props}
      ref={editorRef}
      onFocus={onFocus}
      editorClassName={classNames(styles.root, props.editorClassName)}
      editorState={props.editorState}
      onEditorStateChange={onChange}
      wrapperClassName={styles.wrapperClassName}
      toolbarClassName={styles.toolbarClassName}
    />
  );
};

export default RichTextEditor;
